import React from 'react'
import styled from 'styled-components'

import { Avatar } from '../Avatar'

const Root = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > p {
    color: ${({ theme }) => theme.colors.text};
    opacity: 1 !important;
    font-weight: 500;
    margin-left: 0.5rem !important;
  }
`

export const AuthorChip = ({ avatar, name }) => (
  <Root>
    <Avatar size={1.25} name={name} src={avatar} />
    <p>{name}</p>
  </Root>
)
